<template>
  <div>
    <div class="page-header">
      <div class="page-leftheader">
        <div class="headline">
          <!--
            WAR FALSCH: Diese Überschrift war wortgleich mit der von
            Models.vue ("Alle Modelle") — obwohl es sich um zwei völlig
            verschiedene Seiten handelt. Models.vue zeigt den Fahrzeug-Katalog
            (Automarken/-modelle als Referenzdaten). Diese Seite hier zeigt
            dagegen die tatsächlichen, einem Nutzer gehörenden Fahrzeuge aller
            Nutzer — und bietet Löschen an, was ein echtes Konto verändert.
            Ohne Menüeintrag (siehe main.js) war diese Seite nur über die
            Adresszeile erreichbar; die identische Überschrift verschleierte
            zusätzlich, dass man sich hier nicht auf der harmlosen
            Katalogseite befindet.
          -->
          <h4 class="page-title text-primary">Fahrzeuge aller Nutzer</h4>
        </div>
      </div>
      <div class="page-rightheader">
        <!--
          Hier stand ein Knopf „Modell hinzufügen". Er ist entfernt, weil auf
          dieser Seite kein Fahrzeug angelegt werden kann: /auto/add setzt den
          Besitzer fest auf den angemeldeten Benutzer
          (ETSBackend/controllers/v1/autoController.js:110). Ein hier
          angelegtes Fahrzeug hätte also dem Verwaltungskonto gehört statt
          einem App-Benutzer — die Übersicht kennt gar keine Auswahl des
          Besitzers. Fahrzeuge entstehen in der App beim jeweiligen Benutzer.
        -->
        <a
          class="btn btn-primary btn-pill mr-1"
          @click="$router.push('manufacturers')"
          >Automarken</a
        >
        <!--
          Hier stand ein Auswahlfeld „Search By Date" mit sieben Einträgen.
          Keiner davon hatte ein @click, das Anklicken blieb also folgenlos —
          der Filter sah benutzbar aus, wirkte aber nie. Ein echter
          Zeitraumfilter ist an dieser Stelle auch gar nicht möglich: Die
          beiden Endpunkte dieser Seite, /auto/all/:skip/:limit und
          /auto/search/:searchString/:skip/:limit (ETSBackend/routes/V1.js),
          nehmen ausschließlich skip und limit entgegen und kennen keinen
          Zeitraum. Das tote Bedienelement ist deshalb entfernt, statt
          weiter eine Wirkung vorzutäuschen.
        -->
      </div>
    </div>
    <div>
      <div>
        <input
          v-model="search"
          type="search"
          class="form-control form-control-sm"
          placeholder="Suchen ..."
          aria-controls="example1"
        />
        <br />
      </div>
      <div class="card">
          <div class="table-responsive">
              <table class="table card-table table-vcenter text-nowrap">
                  <thead>
                      <th>Bild</th>
                      <th>Modell</th>
                      <th>Marke</th>
                      <th>Jahr</th>
                      <th>Aktion</th>
                  </thead>
                  <tbody>
                    <tr v-for="model in models" :key="model._id">
                    <td class="align-middle">
                        <!--
                          Hier stand model.galleryImages[0].url ohne jede
                          Prüfung. Das Feld ist optional und hat die Vorgabe []
                          (ETSBackend/models/Auto.js:14) — ein einziges
                          Fahrzeug ohne Bild ließ deshalb schon den Aufbau der
                          Zeile werfen und riss die gesamte Tabelle mit: Die
                          Seite blieb leer. firstImage() liefert stattdessen
                          einen leeren Wert, wie in Posts.vue und Reported.vue.
                        -->
                        <img
                        v-if="firstImage(model)"
                        :src="`${$img(firstImage(model),$awsLargeImages)}`"
                        alt="img"
                        class="avatar avatar-md brround"
                        />
                        <i class="fe fe-image text-muted" v-else title="Kein Bild"></i>
                    </td>
                    <td class="align-middle">{{ model.model }}</td>
                    <td class="align-middle">{{ model.brand }}</td>
                    <td class="align-middle">{{ model.year}}</td>
                    
                    <td>
                      <a
                      class="btn btn-primary btn-small mr-1"
                      @click="openEditModel(model, 'edit')"
                      ><i class="fas fa-edit"></i
                    ></a>
                    <a
                      class="btn btn-small btn-danger"
                      @click="openDeleteModel(model)"
                      ><i class="fas fa-trash-alt"></i
                    ></a>
                    </td>
                      </tr>
                  </tbody>
              </table>
          </div>

      </div>
      <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
    </div>

    <!-- V-Dialoge -->
    <v-dialog 
        v-model="editDialog"
        width="500">
        <v-card>
         <v-card-title class="card">
            <!--
              Die zweite Überschrift „Modell hinzufügen" ist entfernt: Seit der
              Knopf zum Anlegen weg ist (siehe Begründung oben), gibt es den
              Bearbeitungstyp 'new' auf dieser Seite nicht mehr.
            -->
            <h4 class="page-title text-primary">Modell bearbeiten</h4>
          </v-card-title>
          <v-card-text>
            <div class="form-group">
                <label class="form-label">Modell</label>
                <input type="text" class="form-control" placeholder="Modell..." v-model="editModel.model">
            </div>
            <div class="form-group">
                <label class="form-label">Marke</label>
                <input type="text" class="form-control" placeholder="Marke..." v-model="editModel.brand">
            </div>
            <div class="form-group">
                <label class="form-label">Jahr</label>
                <input type="text" class="form-control" placeholder="Jahr..." v-model="editModel.year">
            </div>
            <div class="form-group">
                <label class="form-label">Beschreibung</label>
                <textarea
                  rows="4"
                  class="form-control"
                  placeholder="Beschreibung"
                  v-bind:class="{
                    'is-invalid':
                      editModel.description == null ||
                      editModel.description == '',
                  }"
                  v-model="editModel.description"
                ></textarea>
            </div>
            <!-- <div id="carousel-controls" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                    <div class="carousel-item active" v-for="img in editModel.galleryImages" :key="img.url">
                        <img class="d-block w-100" alt="" :src="`${$img(img.url,$awsLargeImages)}`" data-holder-rendered="true">
                    </div>
                </div>
                <a class="carousel-control-prev" href="#carousel-controls" role="button" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carousel-controls" role="button" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </a>
            </div> -->
          </v-card-text>
            <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="editDialog=false">Abbrechen</a>
              <!--
                Hier stand @click="openEditModel()" — ohne Argumente. Das rief
                initializeModel() auf und leerte damit das Formular, statt zu
                speichern; eine Speicherfunktion gab es in dieser Datei gar
                nicht. Jetzt schreibt saveModel() über PUT /auto/update
                (ETSBackend/routes/V1.js) zurück.
              -->
              <a class="btn btn-primary btn-pill" @click="saveModel()">Speichern</a>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <!--
      Diesem Dialog fehlte die <v-card>-Hülle — ohne sie stand der Inhalt ohne
      Hintergrund und Innenabstand im leeren Fenster. Außerdem war die
      Überschrift aus dem Bearbeiten-Dialog kopiert („Modell bearbeiten" bzw.
      „Modell hinzufügen") und der Text fragte nach einem „Ereigniss" —
      falsches Thema und falsch geschrieben. Der Benutzer konnte also nicht
      erkennen, was er da bestätigt.
    -->
    <v-dialog
        v-model="deleteDialog"
        width="500">
        <v-card>
         <v-card-title class="card">
            <h4 class="page-title text-danger">Fahrzeug eines Nutzers löschen</h4>
          </v-card-title>
          <v-card-text>
            <!--
              WAR FALSCH: "Sind Sie sicher, dass Sie dieses Modell löschen
              möchten?" klang nach einer Katalog-Referenz — tatsächlich
              verschwindet damit ein echtes Fahrzeug aus dem Profil eines
              echten Nutzers, ohne dass hier zu sehen wäre, welcher Nutzer das
              ist (die Übersicht liefert dessen Namen nicht mit, siehe
              autoController.js). Der Text warnt jetzt ausdrücklich, statt es
              wie eine harmlose Katalogpflege aussehen zu lassen.
            -->
            Dieses Fahrzeug gehört einem Nutzer und wird aus dessen Profil
            entfernt — nicht rückgängig zu machen. Betroffen:
            <strong>{{ editModel.brand }} {{ editModel.model }}</strong>
            <span v-if="editModel.year"> ({{ editModel.year }})</span>.
          </v-card-text>
                    <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="deleteDialog=false">Abbrechen</a>
              <a class="btn btn-danger btn-pill" @click="deleteModel()">Löschen</a>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </div>
</template>

<script>


export default {
  components: {},

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 25,
      sort: null,
      order: true,

      history: false,
      
      search: "",

      models: [],
      // Anzahl der zuletzt geladenen Einträge. Stand vorher nirgends in data()
      // und wurde nur nebenbei gesetzt — dadurch fiel auch nicht auf, dass
      // Nachladen und Laden zwei verschiedene Namen benutzten.
      lastModels: null,
      editModel: '',


      editDialog: false,
      deleteDialog: false,
      emptyDialog: false,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    search: function () {
      if (this.search == "") {
        this.fetchModels();
      } else {
        this.page = 0;
        this.searchModels();
      }
    },
  },

  mounted() {
    this.fetchModels();
    
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
            setTimeout(() => {
                var _this = this;
                // Geprüft wurde vorher this.lastCars, geschrieben aber
                // this.lastModels (fetchModels). lastCars blieb dadurch nach
                // einer Suche mit wenigen Treffern auf dem alten Wert stehen —
                // war er kleiner als ElementPerPage, lud die Seite nie wieder
                // nach. Jetzt heißt das Feld überall lastModels.
                if(this.lastModels == this.ElementPerPage || this.lastModels == null){
                  // WAR FALSCH: this.page wurde in beiden Zweigen VOR der
                  // Anfrage hochgezählt. Scheiterte sie (Netzstörung, 401,
                  // 500), blieb der Zähler trotzdem erhöht — die betroffenen
                  // 25 Fahrzeuge waren dauerhaft übersprungen, nur ein
                  // Neuladen der Seite half. Jetzt steigt die Seitenzahl erst
                  // NACH einer erfolgreichen Antwort, wie schon in Models.vue
                  // und Manufacturers.vue.
                  const nextPage = this.page + 1;
                  // WAR FALSCH: response.data.data wurde hier ungeprüft
                  // benutzt. Bei einem fachlichen Fehlschlag (HTTP 200 mit
                  // success:false) liefert dieses Backend gar kein data-Feld —
                  // der Zugriff auf .length warf dann, der Fehler landete still
                  // im .catch und das Nachladen blieb ohne Rückmeldung stehen.
                  // Beide Zweige benutzen jetzt denselben abgesicherten
                  // Anhänger, wie in Users.vue und Reported.vue.
                  const append = function (response) {
                    const neue = (response.data && response.data.data) || [];
                    _this.lastModels = neue.length;
                    if(neue.length >= 1) {
                      _this.page = nextPage;
                      neue.forEach(item => _this.models.push(item));
                    }
                  };
                  if(this.search ==  "" || this.search == null){
                    this.$axios
                          .get('/auto/all/' + nextPage * this.ElementPerPage + '/' + this.ElementPerPage)
                          .then(append)
                          .catch(_this.onError);
                  }
                  else{
                    // Der Suchbegriff steckt im Pfad: Ohne
                    // encodeURIComponent zerlegte schon ein „/" oder „?" die
                    // Adresse, die Anfrage lief auf eine andere Route.
                    this.$axios.get('/auto/search/' + encodeURIComponent(this.search) +'/'+ nextPage * this.ElementPerPage + '/' + this.ElementPerPage)
                          .then(append)
                          .catch(_this.onError);
                  }
                }
            }, 500);
        }
    },
    // Der Fehlerbehandler fehlte, .catch(this.onError) reichte also undefined
    // weiter: Abgelehnte Anfragen liefen ins Leere und waren nirgends zu
    // sehen. Gleiche Umsetzung wie in Events.vue und Users.vue.
    onError(err) {
      if (err != null && err.response != null && err.response.data != null) {
        console.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    // Für Speichern und Löschen reicht ein Eintrag in der Konsole nicht: Der
    // Dialog bleibt bei einem Fehler offen und der Benutzer sähe sonst gar
    // nichts — genau der Zustand, in dem die Knöpfe vorher wirkungslos wirkten.
    onActionError(err) {
      this.onError(err);
      // Bei 401 und 403 meldet sich bereits der zentrale Abfangjäger in
      // main.js. Noty ist mit killer: true eingerichtet — eine zweite Meldung
      // würde die erste sofort schließen und den genauen Hinweis durch einen
      // nichtssagenden ersetzen.
      const status = err != null && err.response != null ? err.response.status : null;
      if (status === 401 || status === 403) return;
      this.$showCommonError();
    },
    fetchModels() {
      var _this = this;
      // page wurde hier nicht zurückgesetzt: Nach dem Scrollen und
      // anschließendem Leeren der Suche zeigte die Liste wieder die ersten 25
      // Einträge, das Nachladen sprang aber bei der alten, hohen Seitenzahl
      // weiter — die Einträge dazwischen fehlten dauerhaft.
      this.page = 0;
      this.$axios
        .get("/auto/all/0/" + this.ElementPerPage)
        .then(function (response) {
          // Dieselbe Absicherung wie beim Nachladen oben: Ohne data-Feld (HTTP
          // 200 mit success:false) warf der Zugriff auf .length und die Liste
          // blieb ohne jede Rückmeldung leer.
          _this.models = (response.data && response.data.data) || [];
          _this.lastModels = _this.models.length;
        })
        .catch(_this.onError);
    },
    // Nach Speichern und Löschen muss die Liste so neu geladen werden, wie sie
    // gerade angezeigt wird. Ein festes fetchModels() hätte bei gefüllter Suche
    // alle Fahrzeuge geholt, obwohl der Suchbegriff noch im Feld steht — beim
    // Weiterscrollen hätte das Nachladen dann Suchtreffer an die vollständige
    // Liste gehängt, mit doppelten _id-Schlüsseln in der Tabelle.
    reloadModels() {
      if (this.search == null || this.search === "") {
        this.fetchModels();
      } else {
        this.page = 0;
        this.searchModels();
      }
    },
    openEditModel(model, type) {
        this.initializeModel();
        if(type == 'edit') {
            // Kopie statt Verweis: Vorher zeigte editModel direkt auf das
            // Objekt aus der Liste. Die Eingabefelder schrieben damit sofort in
            // die Tabellenzeile — „Abbrechen" oder ein fehlgeschlagenes
            // Speichern ließen die geänderten Werte trotzdem stehen, obwohl in
            // der Datenbank nichts geändert wurde. Gleiche Lösung wie in
            // Users.vue (openEditCar).
            this.editModel = Object.assign({}, model);
        }
        this.editModel.editType = type;
        this.editDialog = true;
    },
    // Beide Löschen-Knöpfe zeigten auf Methoden, die es nicht gab
    // (openDeleteModel, deleteModel): Ein Klick blieb ohne jede Wirkung.
    openDeleteModel(model) {
      this.editModel = model;
      this.deleteDialog = true;
    },
    deleteModel() {
      var _this = this;
      // Route: DELETE /auto/delete/:autoId (ETSBackend/routes/V1.js) — genau
      // ein Parameter, die Kennung des Fahrzeugs.
      this.$axios
        .delete("/auto/delete/" + this.editModel._id)
        .then(function (response) {
          // respondFailure antwortet mit HTTP 200 und success: false
          // (ETSBackend/helpers/response.js) — der .catch-Zweig greift dann
          // nicht. Ohne diese Prüfung hätte sich der Dialog geschlossen, als
          // sei gelöscht worden, obwohl der Server nichts geändert hat.
          if (response.data != null && response.data.success === false) {
            _this.onActionError(response.data);
            return;
          }
          _this.deleteDialog = false;
          _this.reloadModels();
        })
        .catch(function (error) {
          _this.onActionError(error);
        });
    },
    saveModel() {
      var _this = this;

      // Pflichtfelder vorab prüfen: brand, model und year sind serverseitig
      // erforderlich (ETSBackend/helpers/inputValidation.js,
      // validateUpdateAuto). Ohne diese Prüfung wies der Server die Anfrage
      // mit 422 zurück und der Knopf sah erneut wirkungslos aus.
      if (this.editModel.brand == null || this.editModel.brand === "") {
        this.$showErrorMissing("Marke");
        return;
      }
      if (this.editModel.model == null || this.editModel.model === "") {
        this.$showErrorMissing("Modell");
        return;
      }
      if (this.editModel.year == null || this.editModel.year === "") {
        this.$showErrorMissing("Jahr");
        return;
      }

      var autoToSave = {
        autoId: this.editModel._id,
        brand: this.editModel.brand,
        model: this.editModel.model,
        year: this.editModel.year,
        // Der Endpunkt baut galleryImages aus existingImages neu auf und liest
        // das Feld ungeprüft mit JSON.parse
        // (ETSBackend/controllers/v1/autoController.js:176). Fehlt es, bricht
        // die Anfrage serverseitig ab; ohne Inhalt wären alle Bilder weg.
        existingImages: JSON.stringify(this.editModel.galleryImages || []),
        deletedImages: JSON.stringify([]),
      };
      // description ist als Joi.string() ohne allow('') beschrieben — ein
      // leerer Text hätte die ganze Anfrage mit 422 abgelehnt. Weggelassen
      // entfernt updateAuto das Feld aus dem Datensatz; beim Lesen greift
      // dann wieder die Vorgabe '' aus dem Schema, der Inhalt ist derselbe.
      if (this.editModel.description != null && this.editModel.description !== "") {
        autoToSave.description = this.editModel.description;
      }
      // category und videoLink dürfen leer sein. Sie werden immer mitgesendet,
      // weil updateAuto sie ungeprüft zuweist — fehlen sie, entfernt Mongoose
      // die Felder aus dem Datensatz.
      autoToSave.category = this.editModel.category != null ? this.editModel.category : "";
      autoToSave.videoLink = this.editModel.videoLink != null ? this.editModel.videoLink : "";

      // Die Route hängt an multipleUpload (multer) und erwartet deshalb
      // multipart/form-data — wie beim Speichern eines Fahrzeugs in Users.vue.
      var body = this.$formatUrlEncoded(autoToSave);
      this.$axios
        .put("/auto/update", body)
        .then(function (response) {
          // Siehe deleteModel: respondFailure liefert HTTP 200 mit
          // success: false, etwa wenn das Fahrzeug zwischenzeitlich gelöscht
          // wurde (ETSBackend/controllers/v1/autoController.js, updateAuto).
          if (response.data != null && response.data.success === false) {
            _this.onActionError(response.data);
            return;
          }
          _this.editDialog = false;
          _this.reloadModels();
        })
        .catch(function (error) {
          _this.onActionError(error);
        });
    },
    // Liefert die erste Bildadresse oder einen leeren Wert. Ohne diesen
    // Umweg griff die Tabelle direkt auf galleryImages[0] zu (siehe Kommentar
    // dort) und warf bei Fahrzeugen ohne Bild.
    firstImage(model) {
      if (!model || !model.galleryImages || model.galleryImages.length === 0) return "";
      return model.galleryImages[0].url;
    },
    searchModels() {
      var _this = this;
      this.$axios
        .get(
          // Ohne encodeURIComponent zerlegte ein „/" oder „?" im Suchbegriff
          // die Adresse und die Anfrage landete auf einer anderen Route.
          "/auto/search/" +
            encodeURIComponent(this.search) +
            "/" +
            this.page +
            "/" +
            this.ElementPerPage
        )
        .then(function (response) {
          // Siehe fetchModels(): ohne data-Feld warf der Zugriff auf .length.
          _this.models = (response.data && response.data.data) || [];
          // Hieß vorher lastCars — geprüft wurde beim Nachladen derselbe Name,
          // geschrieben beim Laden aber lastModels. Jetzt überall lastModels.
          _this.lastModels = _this.models.length;
        })
        .catch(_this.onError);
    },

    initializeModel() {
        this.editModel = {
            brand: '',
            model: '',
            year: '',
            description: '',
            _id: '',
            galleryImages: [],
            editType: '',
        }
    }

   },
};


</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>